import { BASE_URL, GET, DEMAND } from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";

export const fetchServiceDetail = async (requestId) => {
    const token = await getAccessToken();   
    const url = `${BASE_URL}${DEMAND}/${requestId}`;   
    return fetch(url, {
        method: GET,
        headers: {
          "Content-Type": "application/json",
          "userauth" : `bearer ${token}`
        },
      })
      .then(statusParsing)
      .then(jsonParsing);     

};